import {
  CLEAR_PARCELS,
  GET_PARCELS_FAILURE,
  GET_PARCELS_REQUEST,
  GET_PARCELS_SUCCESS,
} from "data/constants"

const defaultState = {
  state: "INITIAL",
  count: 0,
  errors: [],
  list: [],
}

export default function parcels(state = defaultState, action) {
  switch (action.type) {
    case GET_PARCELS_REQUEST:
      return {
        ...state,
        state: "LOADING",
        count: 0,
        errors: [],
        list: [],
      }
    case GET_PARCELS_SUCCESS:
      return {
        ...state,
        state: "LOADED",
        count: action.data.count,
        errors: action.data.errors || [],
        list: action.data.items,
      }
    case GET_PARCELS_FAILURE:
      return {
        ...state,
        state: "FAILED",
        errors: [...state.errors, action.error],
      }
    case CLEAR_PARCELS:
      return defaultState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/data/reducers/parcels.js